<sb-dialog-activation
  [showTitle]="currentStep === OptimizedScheduleDialogStep.TEASER"
  [showBackButton]="currentStep > 0"
  [showProgressBar]="currentStep > 0"
  [currentStep]="currentStep"
  [totalSteps]="steps"
  (back)="goBack()"
>
  <div main-panel>
    @switch (currentStep) {
      @case (OptimizedScheduleDialogStep.TEASER) {
        <chapter-step
          [subtitle]="'Optimised Scheduling' | translate"
          [title]="'Stop firefighting schedules. Start planning ahead.' | translate"
          [nextButtonLabel]="'Start quick setup' | translate"
          (next)="goToStep(OptimizedScheduleDialogStep.BASIC_SETUP)"
        >
          <p class="mb-0 text-base">
            {{
              "When every shift feels like a scramble, it's impossible to think beyond tomorrow. Shiftbase helps you plan smarter, stay ahead, and ensure every shift is covered."
                | translate
            }}
          </p>
          <div class="flex flex-col gap-1">
            <chapter-item
              [text]="'Flexible shift swapping' | translate"
              [description]="'Employees can swap shifts based on availability.' | translate"
            />
            <chapter-item
              [text]="'Smarter planning' | translate"
              [description]="'Manage availability and know exactly who\'s showing up.' | translate"
            />
            <chapter-item
              [text]="'Timely reminders' | translate"
              [description]="'Keep employees informed about upcoming shifts.' | translate"
            />
          </div>
        </chapter-step>
      }
      @case (OptimizedScheduleDialogStep.BASIC_SETUP) {
        <chapter-step
          [title]="'We\'ve enabled some smart scheduling defaults for you.' | translate"
          [nextButtonLabel]="hasPremium ? ('Got it!' | translate) : ('Show me a quick tour' | translate)"
          [nextButtonLoading]="nextButtonLoading"
          (next)="goToStep(OptimizedScheduleDialogStep.EMPLOYEE_AVAILABILITY)"
        >
          <p class="mb-0 text-base">
            {{
              'These tools are ready to go, helping you fill shifts quickly and reduce scheduling stress.' | translate
            }}
          </p>
          <div class="flex flex-col gap-1">
            <chapter-item
              [text]="'Availability Management' | translate"
              [description]="
                'Keep track of when employees are available to plan schedules with confidence.' | translate
              "
            />
            <chapter-item
              [text]="'Open Shifts' | translate"
              [description]="
                'Employees can claim available shifts to ensure gaps are filled without extra work for you.' | translate
              "
            />
            <chapter-item
              [text]="'Shift Exchanges' | translate"
              [description]="
                'Allow employees to swap shifts based on availability, giving you flexibility while avoiding conflicts.'
                  | translate
              "
            />
          </div>
          @if (hasPremium) {
            <p class="mb-0 text-base">
              {{ 'You can adjust these defaults anytime in your settings.' | translate }}
            </p>
          }
        </chapter-step>
      }
      @case (OptimizedScheduleDialogStep.EMPLOYEE_AVAILABILITY) {
        <chapter-step
          [title]="'Set when employees should confirm their availability.' | translate"
          [nextButtonLabel]="'Show me a quick tour' | translate"
          [nextButtonLoading]="nextButtonLoading"
          (next)="savePreferencesAndClose()"
        >
          <div class="flex flex-col gap-2">
            <p class="m-0 text-base">
              {{ 'Finalize employee availability' | translate }}
            </p>
            <sb-radio-badge-group data-testid="week-amount-input" [(ngModel)]="availabilityWeekAmount">
              @for (option of availabilityWeekAmountOptions; track option.value) {
                <sb-radio-badge [value]="option.value">{{ option.label }}</sb-radio-badge>
              }
            </sb-radio-badge-group>
            <p class="m-0 font-medium text-support">
              {{ 'before the week starts (Monday)' | translate }}
            </p>
          </div>
          <p class="m-0 mt-4 text-base">
            {{ 'You can adjust this later in your settings.' | translate }}
          </p>
        </chapter-step>
      }
    }
  </div>
  <div
    class="flex size-full min-h-72 overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat lg:mr-12"
    aside-panel
    [ngStyle]="{
      backgroundImage: 'url(assets/images/onboarding/chapters/optimised-scheduling.jpg)'
    }"
  ></div>
</sb-dialog-activation>
